import React from 'react';
import './ISBC.css';
import StickyVideoUp from '../../StickyVideoUp';
import Slide1 from "../../../assests/OK images/Slide1.webp"
import Slide2 from "../../../assests/OK images/Slide2.webp"
import Slide3 from "../../../assests/OK images/Slide3.webp"
import Slide4 from "../../../assests/OK images/Slide4.webp"
import Slide5 from "../../../assests/OK images/Slide5.webp"
import Slide6 from "../../../assests/OK images/Slide6.webp"
import Slide7 from "../../../assests/OK images/Slide7.webp"
import Slide8 from "../../../assests/OK images/Slide8.webp"
import Slide9 from "../../../assests/OK images/Slide9.webp"
import Slide10 from "../../../assests/OK images/Slide10.webp"
import Slide11 from "../../../assests/OK images/Slide11.webp"
import Slide12 from "../../../assests/OK images/Slide12.webp"
import Slide13 from "../../../assests/OK images/Slide13.webp"
import Slide14 from "../../../assests/OK images/Slide14.webp"

function ISBC() {
  const imagePaths = [
    Slide1,
    Slide2,
    Slide3,
    Slide4,
    Slide5,
    Slide6,
    Slide7,
    Slide8,
    Slide9,
    Slide10,
    Slide11,
    Slide12,
    Slide13,
    Slide14,
  ];

  return (
    <>
      <StickyVideoUp />
      <div className='IsbcpdfContainer'>
        {imagePaths.map((path, index) => (
          <div key={index} className='IsbcPdfImg'>
            <img className='images-isbc-pdf' src={path} alt='isbc' />
          </div>
        ))}
      </div>
    </>
  );
}

export default ISBC;
